import React from 'react';
import { Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'ui/Typography/Text';
import RadioGroup from './RadioGroup';
import SelectMenu from './SelectMenu';

/*::
type FilterOptionsProps = {
  value: string,
  name: string,
  onChange: string => void,
  options: Array<{
    label: string,
    value: string,
  }>,
}
*/

const SearchFilter = ({
  title,
  ...filterOptionsProps /*: FilterOptionsProps */
}) => (
  <div className="LearnSearchFilter">
    <Text
      variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
      component="h4"
      className="LearnSearchFilter-title"
    >
      {title}
    </Text>
    <div className="LearnSearchFilter-radioGroup">
      <RadioGroup {...filterOptionsProps} />
    </div>
    <div className="LearnSearchFilter-selectMenu">
      <SelectMenu {...filterOptionsProps} />
      <Icon name="caret_down" className="LearnSearchFilter-selectMenuIcon" />
    </div>
  </div>
);

export default SearchFilter;
